import {Text} from '@mantine/core';
import React from 'react';

import type {BoltzApiSpendSummary} from './BoltzApiService';

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  style: 'currency',
});

interface BoltzApiSpendUsageProps {
  spendSummary: BoltzApiSpendSummary;
}

function getUsagePercentage({accruedSpend, spendLimit}: BoltzApiSpendSummary): number {
  if (spendLimit <= 0) {
    return 0;
  }
  const usagePercentage = Math.round((100 * accruedSpend) / spendLimit);
  return Math.max(0, Math.min(100, usagePercentage));
}

export default function BoltzApiSpendUsage({spendSummary}: BoltzApiSpendUsageProps): JSX.Element {
  const {accruedSpend, spendLimit} = spendSummary;
  const usagePercentage = getUsagePercentage(spendSummary);

  return (
    <Text aria-label="Boltz API spend usage" role="status" size="sm">
      {USD_FORMATTER.format(accruedSpend)} of {USD_FORMATTER.format(spendLimit)} has been used (
      {usagePercentage}% used)
    </Text>
  );
}
